import { useGLTF } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { useEffect } from 'react'

// const LogoMain = ({ model, position, rotation, scale }) => {
const LogoMain = ({
  model,
  model2,
  model3 = null,
  position,
  rotation = [0, 0, 0],
  scale = 1,
  position2,
  rotation2,
  scale2 = 1,
  position3,
  rotation3 = [0, 0, 0],
  scale3 = 1,
}) => {
  const snap = useSnapshot(state.current)
  // const { nodes, materials } = useGLTF(model)
  // console.log(materials)

  const EnjoyLogo = () => {
    const { nodes, materials } = useGLTF(model)

    useEffect(() => {
      if (!materials.MainLogoWhite) return

      materials.MainLogoWhite.roughness = 1
      materials.MainLogoWhite.metalness = 0

      // BIG one
      materials.MainLogoWhite.envMapIntensity = 0.00010

      materials.MainLogoWhite.needsUpdate = true
    }, [materials])


    return (
      <group position={position} rotation={rotation} scale={scale}>
        <mesh
          castShadow
          geometry={nodes.Mesh.geometry}
          material={materials.MainLogoBlack}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1.geometry}
          material={materials.MainLogoWhite}
        />
      </group>
    )
  }
  const HexLogo = () => {
    const { nodes, materials } = useGLTF(model2)

    useEffect(() => {
      if (!materials.HexaLogoWhite) return

      materials.HexaLogoWhite.roughness = 1
      materials.HexaLogoWhite.metalness = 0

      // BIG one
      materials.HexaLogoWhite.envMapIntensity = 0.5

      materials.HexaLogoWhite.needsUpdate = true
    }, [materials])


    return (
      <group position={position2} rotation={rotation2} scale={scale2}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh.geometry}
          material={materials.HexaLogoBlack}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1.geometry}
          material={materials.HexaLogoWhite}
        />
      </group>
    )
  }
  const SuperLogo = () => {
    const { nodes, materials } = useGLTF(model3)

    useEffect(() => {
      if (!materials.MainLogoWhite) return

      materials.MainLogoWhite.roughness = 1
      materials.MainLogoWhite.metalness = 0

      // BIG one
      materials.MainLogoWhite.envMapIntensity = 1

      materials.MainLogoWhite.needsUpdate = true
    }, [materials])

    return (
      <group position={position3} rotation={rotation3} scale={scale3}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh.geometry}
          material={materials.MainLogoBlack}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1.geometry}
          material={materials.MainLogoWhite}
        />
      </group>
    )
  }


  return (
    <group dispose={null}>
      {snap.choices.topLogo.selected.mode === 'enjoy' && <EnjoyLogo />}
      {snap.choices.topLogo.selected.mode === 'hex' && <HexLogo />}
      {model3 && snap.choices.topLogo.selected.mode === 'super' && <SuperLogo />}
    </group>
  )

}

export default LogoMain

// useGLTF.preload(model)
// useGLTF.preload(model2)
